import React from 'react';

const ModeloFaturamentoContext = React.createContext();

export default ModeloFaturamentoContext;
